import React from 'react';
import { Preset } from '../../types/presets';
import './ScreenerHeader.css';

interface ScreenerHeaderProps {
  activePreset: Preset | null;
  basePreset: Preset | null;
  isModified: boolean;
  resultCount: number;
  isLoading: boolean;
  onSaveAsPreset: () => void;
}

const ScreenerHeader: React.FC<ScreenerHeaderProps> = ({
  activePreset,
  basePreset,
  isModified,
  resultCount,
  isLoading,
  onSaveAsPreset,
}) => {
  // Don't render if no context at all
  if (!activePreset && !basePreset) {
    return null;
  }

  const getHeaderInfo = () => {
    if (isModified && basePreset) {
      return {
        title: 'Custom Screen',
        description: `Filters modified based on '${basePreset.name}' preset.`,
        color: '#6B7280',
        showSaveButton: true
      };
    }

    if (activePreset) {
      return {
        title: activePreset.name,
        description: activePreset.description || '',
        color: '#3B82F6',
        showSaveButton: false
      };
    }

    return null;
  };

  const headerInfo = getHeaderInfo();
  if (!headerInfo) return null;

  return (
    <div
      className="screener-header"
      style={{ '--header-accent-color': headerInfo.color } as React.CSSProperties}
    >
      <div className="screener-header-content">
        <div className="screener-header-text">
          <h1 className="screener-header-title">
            {headerInfo.title}
            {!isModified && activePreset && (
              <span className="screener-header-active-badge">Active</span>
            )}
          </h1>
          {headerInfo.description && (
            <p className="screener-header-description">{headerInfo.description}</p>
          )}
        </div>

        <div className="screener-header-meta">
          <span className="screener-header-count">
            {isLoading ? (
              <span className="screener-header-loading">Loading...</span>
            ) : (
              `${resultCount.toLocaleString()} Matches Found`
            )}
          </span>

          {headerInfo.showSaveButton && (
            <button
              className="screener-header-save-btn"
              onClick={onSaveAsPreset}
            >
              Save as New Preset
            </button>
          )}
        </div>
      </div>

      {/* Accent line */}
      <div
        className="screener-header-accent"
        style={{ backgroundColor: headerInfo.color }}
      />
    </div>
  );
};

export default ScreenerHeader;
